import {SupplierOrderStatusTypes} from "./enum";
import {grey} from "@mui/material/colors";

const SupplierOrderStatusColors: Record<SupplierOrderStatusTypes, string> = {
    [SupplierOrderStatusTypes.PENDING_ORDER]: '#FFC107', 
    [SupplierOrderStatusTypes.PENDING_DELIVERY]: '#DAA520',
    [SupplierOrderStatusTypes.DELIVERED]: '#32CD32',
    [SupplierOrderStatusTypes.CANCELLED]: '#DC143C'
}

export const getSupplierOrderStatusColor = (status: SupplierOrderStatusTypes) => SupplierOrderStatusColors[status] || grey[400]